import React from "react";
import ReactDOM from "react-dom";
import Projects from "./Projects";



function Project() {
    return (
        <div id="myprojects">
            <h1 className="project-heading">My Project</h1>
            <div className="projects">
                <div className="eachproject">
                    <Projects image="./image/metaverse.png.png" alt="Card image cap"
                        text="Metaverse Madness" address="https://metaverse-madness-ochre.vercel.app" />
                </div>
                <div className="eachproject">
                    <Projects image="./image/google-clone.png" alt="Card image cap"
                        text=" Google Clone" address="https://google-clone-six-blue.vercel.app/" />
                </div>
                <div className="eachproject">
                    <Projects image="./image/weather-app.png" alt="Card image cap"
                        text="Weather-app" address="http://weather-app-siyavats06.vercel.app/" />

                </div>



                





            </div>



        </div>


    );
}


export default Project;